import React, { useState } from 'react';
import { submissionURL } from '../graphic';

import {
  Checkbox,
  Button,
  Grid,
  FormControl,
  FormHelperText,
  FormControlLabel,
  IconButton,
  Paper,
  Snackbar,
  TextField,
  Typography,
} from '@material-ui/core'

import CloseIcon from '@material-ui/icons/Close';

function Form(props) {
  const { classes } = props;

  const [submission, setSubmission] = useState({
    story: '',
    name: '',
    location: '',
    timeline: '',
    affiliation: '',
    email: '',
    socialMedia: '',
    facebook: false,
    instagram: false,
    twitter: false,
  });

  const [userAgrees, setUserAgreement] = useState(false);
  const [resError, setResError] = useState(false);
  const [open, setOpen] = useState(false);
  const [submitted, storySubmitted] = useState(false);

  function handleChange(event) {
    const { target } = event;
    const { id, value, type, checked } = target;

    setSubmission({
      ...submission,
      [id]: type === 'checkbox' ? checked : value,
    });
  }

  function handleAgreement(event) {
    setUserAgreement(!userAgrees);
  }

  function handleSubmit() {
    storySubmitted(true);

    fetch(submissionURL, {
      method: 'POST',
      mode: 'no-cors',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(submission),
    })
    .then((res) => {
    // successful submission
      setOpen(true);
      storySubmitted(true);
    })
    .catch((err) => {
    // unsuccessful submission
      setOpen(true);
      setResError(true);
    });
  }

  function handleClose() {
    setOpen(false);
  }

  return (
    <form className={classes.form}>
      <Grid className={classes.root} container spacing={2}>
        <Grid item xs={12}>
          <TextField
            multiline
            id='story'
            fullWidth={true}
            rows={5}
            variant='outlined'
            label='Tell us about your tech'
            value={submission.story}
            onChange={handleChange}
            // placeholder='Required'
            className={classes.textField}
            InputLabelProps={{
              classes: {
                root: classes.outlinedInput,
                shrink: classes.shrunkInput,
                // hello: 'hello'
              },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            id='name'
            fullWidth={true}
            // rows={10}
            // variant='outlined'
            placeholder='What is your name?'
            label='What is your name?'
            value={submission.name}
            onChange={handleChange}
            className={classes.textField}
            InputLabelProps={{
              classes: {
                animated: classes.animatedInput,
                root: classes.rootInput,
                shrink: classes.focusedInput,
              },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            id='location'
            placeholder='Where are you based?'
            fullWidth={true}
            label='Where are you based?'
            value={submission.location}
            onChange={handleChange}
            className={classes.textField}
            InputLabelProps={{
              classes: {
                animated: classes.animatedInput,
                root: classes.rootInput,
                focused: classes.focusedInput,
              },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            id='timeline'
            fullWidth={true}
            // rows={10}
            // variant='outlined'
            label='What is the timeline of your project?'
            placeholder='What is the timeline of your project?'
            value={submission.timeline}
            onChange={handleChange}
            className={classes.textField}
            InputLabelProps={{
              classes: {
                animated: classes.animatedInput,
                root: classes.rootInput,
                shrink: classes.focusedInput,
              },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            id='affiliation'
            fullWidth={true}
            // rows={10}
            // variant='outlined'
            label='Which university/institution are you affiliated with?'
            placeholder='Which university/institution are you affiliated with?'
            value={submission.affiliation}
            onChange={handleChange}
            className={classes.textField}
            InputLabelProps={{
              classes: {
                animated: classes.animatedInput,
                root: classes.rootInput,
                shrink: classes.focusedInput,
              },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            id='email'
            fullWidth={true}
            // rows={10}
            // variant='outlined'
            label='Email address'
            placeholder='Email address'
            value={submission.email}
            onChange={handleChange}
            className={classes.textField}
            InputLabelProps={{
              classes: {
                animated: classes.animatedInput,
                root: classes.rootInput,
                shrink: classes.focusedInput,
              },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            id='socialMedia'
            fullWidth={true}
            // rows={10}
            // variant='outlined'
            label='Social media handle'
            placeholder='Social media handle'
            value={submission.socialMedia}
            onChange={handleChange}
            className={classes.textField}
            InputLabelProps={{
              classes: {
                animated: classes.animatedInput,
                root: classes.rootInput,
                shrink: classes.focusedInput,
              },
            }}
          />

          <div className="social-media">
            <FormControl
              component="fieldset"
              class="social-media-checkbox">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={submission.facebook}
                    onChange={handleChange}
                    id="facebook"
                    value="facebook"
                    color="primary"
                  />
                }
              // label="Facebook"
              />
              <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.0611 0C15.6177 0 20.1222 4.50451 20.1222 10.0611C20.1222 15.083 16.443 19.2452 11.6332 20V12.9694H13.9775L14.4235 10.0611H11.6332V8.17387C11.6332 7.37822 12.023 6.60261 13.2728 6.60261H14.5415V4.12663C14.5415 4.12663 13.3901 3.93012 12.2893 3.93012C9.99116 3.93012 8.48906 5.32296 8.48906 7.84452V10.0611H5.93448V12.9694H8.48906V20C3.67918 19.2452 0 15.0828 0 10.0611C0 4.50451 4.50451 0 10.0611 0Z" fill="#0C0C0C" />
              </svg>
            </FormControl>
            <FormControl
              component="fieldset"
              class="social-media-checkbox">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={submission.instagram}
                    onChange={handleChange}
                    id="instagram"
                    value="instagram"
                    color="primary"
                  />
                }
              // label="Instagram"
              />
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.85842 2.07006C6.79442 2.12026 6.06782 2.29006 5.43262 2.53966C4.77522 2.79586 4.21802 3.13966 3.66362 3.69606C3.10922 4.25246 2.76782 4.81006 2.51342 5.46846C2.26722 6.10506 2.10042 6.83226 2.05342 7.89686C2.00642 8.96146 1.99602 9.30366 2.00122 12.0193C2.00642 14.7349 2.01842 15.0753 2.07002 16.1421C2.12082 17.2059 2.29002 17.9323 2.53962 18.5677C2.79622 19.2251 3.13962 19.7821 3.69622 20.3367C4.25282 20.8913 4.81002 21.2319 5.47002 21.4867C6.10602 21.7325 6.83342 21.9001 7.89782 21.9467C8.96222 21.9933 9.30482 22.0041 12.0196 21.9989C14.7344 21.9937 15.0762 21.9817 16.1428 21.9311C17.2094 21.8805 17.932 21.7101 18.5676 21.4617C19.225 21.2045 19.7824 20.8617 20.3366 20.3049C20.8908 19.7481 21.232 19.1901 21.4862 18.5313C21.7326 17.8953 21.9 17.1679 21.9462 16.1043C21.9928 15.0369 22.0038 14.6961 21.9986 11.9809C21.9934 9.26566 21.9812 8.92526 21.9306 7.85886C21.88 6.79246 21.7106 6.06826 21.4612 5.43246C21.2042 4.77506 20.8612 4.21846 20.3048 3.66346C19.7484 3.10846 19.19 2.76746 18.5314 2.51386C17.895 2.26766 17.168 2.09986 16.1036 2.05386C15.0392 2.00786 14.6966 1.99606 11.9808 2.00126C9.26502 2.00646 8.92502 2.01806 7.85842 2.07006ZM7.97522 20.1477C7.00022 20.1053 6.47082 19.9433 6.11802 19.8077C5.65082 19.6277 5.31802 19.4101 4.96642 19.0619C4.61482 18.7137 4.39882 18.3797 4.21642 17.9135C4.07942 17.5607 3.91442 17.0319 3.86882 16.0569C3.81922 15.0031 3.80882 14.6867 3.80302 12.0169C3.79722 9.34706 3.80742 9.03106 3.85362 7.97686C3.89522 7.00266 4.05822 6.47266 4.19362 6.12006C4.37362 5.65226 4.59042 5.32006 4.93942 4.96866C5.28842 4.61726 5.62142 4.40086 6.08802 4.21846C6.44042 4.08086 6.96922 3.91726 7.94382 3.87086C8.99842 3.82086 9.31442 3.81086 11.9838 3.80506C14.6532 3.79926 14.97 3.80926 16.025 3.85566C16.9992 3.89806 17.5294 4.05946 17.8816 4.19566C18.349 4.37566 18.6816 4.59186 19.033 4.94146C19.3844 5.29106 19.601 5.62286 19.7834 6.09046C19.9212 6.44186 20.0848 6.97046 20.1308 7.94566C20.181 9.00026 20.1924 9.31646 20.1972 11.9857C20.202 14.6549 20.1926 14.9719 20.1464 16.0257C20.1038 17.0007 19.9422 17.5303 19.8064 17.8835C19.6264 18.3505 19.4094 18.6835 19.0602 19.0347C18.711 19.3859 18.3784 19.6023 17.9116 19.7847C17.5596 19.9221 17.0302 20.0861 16.0564 20.1325C15.0018 20.1821 14.6858 20.1925 12.0154 20.1983C9.34502 20.2041 9.03002 20.1933 7.97542 20.1477M16.1274 6.65546C16.1278 6.89281 16.1986 7.12472 16.3308 7.32185C16.463 7.51897 16.6507 7.67247 16.8701 7.76292C17.0896 7.85336 17.3309 7.8767 17.5636 7.82998C17.7963 7.78326 18.01 7.66857 18.1775 7.50043C18.345 7.33229 18.4589 7.11824 18.5048 6.88536C18.5507 6.65248 18.5264 6.41123 18.4352 6.19211C18.3439 5.973 18.1898 5.78587 17.9921 5.65439C17.7945 5.52291 17.5624 5.45299 17.325 5.45346C17.0068 5.4541 16.7019 5.58108 16.4773 5.80649C16.2527 6.03189 16.1269 6.33727 16.1274 6.65546ZM6.86542 12.0101C6.87102 14.8461 9.17422 17.1399 12.0096 17.1345C14.845 17.1291 17.1404 14.8261 17.135 11.9901C17.1296 9.15406 14.8258 6.85966 11.99 6.86526C9.15422 6.87086 6.86002 9.17446 6.86542 12.0101ZM8.66662 12.0065C8.66531 11.3472 8.85954 10.7023 9.22473 10.1534C9.58992 9.60452 10.1097 9.17624 10.7183 8.92274C11.3269 8.66924 11.997 8.6019 12.6439 8.72924C13.2907 8.85658 13.8853 9.17287 14.3524 9.63813C14.8195 10.1034 15.1382 10.6967 15.2681 11.3431C15.398 11.9894 15.3333 12.6598 15.0822 13.2694C14.8311 13.879 14.4049 14.4004 13.8574 14.7678C13.31 15.1352 12.6659 15.332 12.0066 15.3333C11.5689 15.3342 11.1352 15.2489 10.7304 15.0822C10.3256 14.9155 9.95765 14.6706 9.64749 14.3617C9.33734 14.0528 9.09107 13.6858 8.92277 13.2817C8.75447 12.8775 8.66743 12.4442 8.66662 12.0065Z" fill="#0C0C0C" />
              </svg>
            </FormControl>
            <FormControl
              component="fieldset"
              class="social-media-checkbox">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={submission.twitter}
                    onChange={handleChange}
                    id="twitter"
                    value="twitter"
                    color="primary"
                  />
                }
              // label="Twitter"
              />

<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M6.74309 9.12904L0 0.75H5.34101L9.50347 5.92882L13.9504 0.773318H16.8919L10.9257 7.69836L18 16.5H12.6749L8.16784 10.8994L3.35607 16.4845H0.398583L6.74309 9.12904ZM13.4511 14.9475L3.27493 2.30249H4.56424L14.7276 14.9475H13.4511Z" fill="#0C0C0C"/>
</svg>

          </FormControl>
          </div>
        </Grid>
        
        <Grid item xs={12}>
          <Typography className={classes.disclaimer} variant='subtitle2'>
            By submitting your story, including your name, and any other personal information (“Story”) you agree that
            your Story may be used, published and distributed by CNN, its affiliates and licensees worldwide on all media
            and platforms for editorial purposes without any limitation in time in accordance with <a href='https://www.cnn.com/2014/01/17/cnn-info/interactive-legal/index.html' target='_blank'>CNN’s terms of service</a>.
            You also agree that we may use any personal contact information you provide to contact you about your Story
            and that we will use such personal contact information in accordance with our privacy policy located
            at <a href='https://www.cnn.com/privacy' target='_blank'>cnn.com/privacy</a>.
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          style={{
            paddingTop: 0,
            paddingBottom: 0,
          }}>
          <FormControl
            // required
            error={!userAgrees}
            disabled={submitted}
            component="fieldset" >
              <FormControlLabel
              control={
                <Checkbox
                  checked={userAgrees}
                  onChange={handleAgreement}
                  value="agree"
                  color="primary"
                />
              }
              label="I agree"
            />
          </FormControl>
        </Grid>
        <Grid style={{
          paddingBottom: 0,
        }} item xs={12}>
          <Button
            disabled={!userAgrees || !submission.story.length || !submission.name.length || !submission.email.length || submitted}
            className={classes.button}
            variant='contained'
            color="primary"
            size='medium'
            onClick={handleSubmit}>
            {submitted ? 'Submitted' : 'Submit'}
          </Button>
        </Grid>
      </Grid>
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        open={open}
        className={classes.snackbarContent}
        ContentProps={{
          className: classes.snackbarContent,
          'aria-describedby': 'message-id',
        }}
        autoHideDuration={6000}
        onClose={handleClose}
        message={
          resError
            ? <span id='message-id'>There was an error.<br/>Please try submitting again</span>
            : <span id="message-id"><strong>Thank you!</strong><br/>Your story has been submitted</span>
        }
        action={[
          <IconButton
            key="close"
            aria-label="Close"
            color="inherit"
            className={classes.close}
            onClick={handleClose}
          >
            <CloseIcon />
          </IconButton>,
        ]}
      />
    </form>
  );
}

export default Form;
